import { JWTRole } from "@hackthenorth/north";
import { z } from "zod";

const hardwareSchema = z.object({
  isOpen: z.boolean().catch(false),
  takingRequests: z.boolean().catch(false),
  volunteersWithAccess: z.array(z.string()).catch([]),
});

const defaultHardware = {
  isOpen: false,
  takingRequests: false,
  volunteersWithAccess: [] as string[],
};

export type HardwareConfig = typeof defaultHardware;

export const parseHardware = (value: unknown): HardwareConfig => {
  const result = hardwareSchema.safeParse(value);

  return result.success ? result.data : defaultHardware;
};

export const isHardwareOrganizer = (
  roles: JWTRole[],
  isOrganizer: boolean,
  email: string | null = null,
  volunteersWithAccess: string[] = []
): boolean =>
  isOrganizer ||
  (roles.includes(JWTRole.VOLUNTEER) &&
    !!email &&
    volunteersWithAccess.some(
      (allowedEmail) => allowedEmail.toLowerCase() === email.toLowerCase()
    ));

/**
 * Hardware is organizers, allowlisted volunteers, and hackers. Organizers
 * and volunteers on `eventMeta.hardware.volunteersWithAccess` keep access
 * while the section is closed; hackers need `eventMeta.hardware.isOpen`.
 * Other roles (sponsor, general, non-allowlisted volunteer, …) are denied
 * here. Independent of the shared hacker post-RSVP tools gate.
 */
export const canAccessHardware = (
  roles: JWTRole[],
  isOrganizer: boolean,
  hardwareOpen: boolean,
  email: string | null = null,
  volunteersWithAccess: string[] = []
): boolean =>
  isHardwareOrganizer(roles, isOrganizer, email, volunteersWithAccess) ||
  (roles.includes(JWTRole.HACKER) && hardwareOpen);
